import React from "react";
import { motion } from "framer-motion";

export default function PageHero({ eyebrow, title, image, height = "72vh", overlay = 45, focal = "center" }) {
  return (
    <section
      className="relative w-full overflow-hidden bg-matte"
      style={{ height }}
      data-testid="page-hero"
    >
      {image && (
        <img
          src={image}
          alt={title || ""}
          className="absolute inset-0 w-full h-full object-cover"
          style={{ objectPosition: focal }}
        />
      )}
      <div className="absolute inset-0 bg-matte" style={{ opacity: (overlay ?? 45) / 100 }} />
      {(eyebrow || title) && (
        <div className="relative z-10 h-full max-w-[1500px] mx-auto px-6 md:px-10 flex flex-col justify-end pb-16 md:pb-20">
          <motion.div
            initial={{ opacity: 0, y: 24 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1, delay: 0.3 }}
          >
            {eyebrow && <p className="text-brass text-[12px] uppercase tracking-editorial mb-4">{eyebrow}</p>}
            {title && (
              <h1 className="font-serif text-ivory text-4xl sm:text-5xl lg:text-6xl font-light leading-[1.08] max-w-3xl">
                {title}
              </h1>
            )}
          </motion.div>
        </div>
      )}
    </section>
  );
}
